import { toLargestExactUnit } from '@supply-mover-2-0/core';

/** The translation function from `useTranslation()`. */
type TranslateModel = (
	key: string,
	params?: Record<string, string | number | null | undefined>,
) => string;

/**
 * The message shown after an idle sign-out, naming the tenant's limit in the
 * largest unit that holds it exactly (PD-17336). Limits can now run to
 * weeks, and "signed out after 43200 minutes" reads badly; this says
 * "30 days". The minutes wording keeps the PD-16414 translation key.
 */
export function formatIdleSignOutMessage(
	t: TranslateModel,
	limitMinutes: number | null,
): string {
	if (limitMinutes == null || !(limitMinutes > 0)) {
		return t('You were signed out because of inactivity.');
	}
	const { amount, unit } = toLargestExactUnit(limitMinutes);
	switch (unit) {
		case 'days':
			return amount === 1
				? t('You were signed out after 1 day of inactivity.')
				: t('You were signed out after {{days}} days of inactivity.', {
						days: amount,
					});
		case 'hours':
			return amount === 1
				? t('You were signed out after 1 hour of inactivity.')
				: t('You were signed out after {{hours}} hours of inactivity.', {
						hours: amount,
					});
		case 'minutes':
			return amount === 1
				? t('You were signed out after 1 minute of inactivity.')
				: t('You were signed out after {{minutes}} minutes of inactivity.', {
						minutes: amount,
					});
	}
}
